import React from 'react';
import Victual from '../../Victual/Victual';

export default () => {
  return (
    <div className='list'>
      <h2 id='soups'>Soups</h2>
      <Victual name='Miso Ramen'
        desc='Soup with soy pasta and egg'
        price='1.35' />
      <Victual name='Soy Ramen'
        desc='Lorum ipsum'
        price='1.35' />
      <Victual name='Curry Ramen'
        desc='Lorum ipsum'
        price='1.35' />
      <Victual name='Shio Ramen'
        desc='Lorum ipsum'
        price='1.35' />
    </div>

  )
}



// WEBPACK FOOTER //
// ./src/components/Menu/Categories/Soups/Soups.js